export const isElectronApp = () =>
  process.env.REACT_APP_DESKTOP === "true" ||
  process.env.REACT_APP_DESKTOP === true;
